import script from "./VirtualSettingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./VirtualSettingPage.vue?vue&type=script&setup=true&lang=js"

import "./VirtualSettingPage.vue?vue&type=style&index=0&id=1e4152f3&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e4152f3"]])

export default __exports__